import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { ko } from 'date-fns/locale';
import { TIMEZONE } from '@mudong/shared';

export function formatKRW(amount: number): string {
  return new Intl.NumberFormat('ko-KR').format(amount) + '원';
}

export function toKst(date: Date | string): Date {
  const d = typeof date === 'string' ? new Date(date) : date;
  return toZonedTime(d, TIMEZONE);
}

export function formatDateKo(date: Date | string, pattern = 'M월 d일(EEE)'): string {
  return format(toKst(date), pattern, { locale: ko });
}

export function formatTimeKo(date: Date | string, pattern = 'a h시 mm분'): string {
  return format(toKst(date), pattern, { locale: ko });
}

export function formatDateTimeKo(date: Date | string): string {
  return `${formatDateKo(date)} ${formatTimeKo(date)}`;
}

export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return phone;
}
